import { language } from '@tencent/ppd-base-libs';
/** 设置HTML元素上的lang属性，便于无障碍准确识别多语言 */
export function setHtmlLang() {
  const lang = language.getLanguage();
  document.documentElement.setAttribute('lang', lang === 'en' ? 'en' : 'zh');
  return { curLang: lang };
}
